import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Sticker Mule Case Study | Canny';
const Description = 'Read about how Sticker Mule uses Canny to reveal big wins.';
const Image = 'https://canny.io/images/helmet-stickermule-case-study.jpg';

export default class StickerMuleLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/case-studies/stickermule' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
